/*
 * @Author: your name
 * @Date: 2020-04-17 15:45:43
 * @LastEditTime: 2020-08-14 17:55:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \musicshop_resource\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
Vue.use(VueResource)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: () => import('./../views/Home'),
      children: [
        {
          path: '',
          component: () => import('./../views/Index/firstPage.vue'),
          name: '',
          hidden: true
        },
        {
          path: '/index',
          component: () => import('./../views/Index/firstPage.vue'),
          name: '首页',
          icon: 'icon-music1',
          redirect: '/index/firstPage',
          meta: {
            keepAlive: true
          },
          children: [
            {
              path: 'firstPage',
              component: () => import('./../views/Index/firstPage.vue'),
              name: '首页列表',
              hidden: true
            },
            // {
            //   path: "vipList",
            //   component: () => import("./../views/Index/vipList.vue"),
            //   name: "会员首页列表",
            //   hidden: true
            // },
            {
              path: 'collection',
              component: () => import('../views/Index/Details.vue'),
              name: '在售歌曲详情',
              hidden: true
            },
            {
              path: 'mindCollection',
              component: () => import('../views/mindCollection.vue'),
              name: '我的收藏',
              hidden: true
            }
          ]
        },
        {
          path: '/index',
          component: () => import('./../views/Index/Index.vue'),
          name: '在售作品',
          icon: 'icon-zuop1',
          redirect: '/index/list',
          meta: {
            keepAlive: true
          },
          children: [
            {
              path: 'list',
              component: () => import('./../views/Index/List.vue'),
              name: '首页列表',
              hidden: true
            },
            // {
            //   path: "vipList",
            //   component: () => import("./../views/Index/vipList.vue"),
            //   name: "会员首页列表",
            //   hidden: true
            // },
            {
              path: 'collection',
              component: () => import('../views/Index/Details.vue'),
              name: '在售歌曲详情',
              hidden: true
            },
            {
              path: 'mindCollection',
              component: () => import('../views/mindCollection.vue'),
              name: '我的收藏',
              hidden: true
            }
          ]
        },
        {
          path: '/broadcast',
          component: () => import('./../views/Index/broadcastIndex.vue'),
          redirect: '/broadcast/list',
          name: '音乐圈',
          icon: 'icon-yyq',
          meta: {
            keepAlive: true
          },
          children: [
            {
              path: 'list',
              component: () => import('../views/broadcastList.vue'),
              name: '音乐圈',
              hidden: true
            },
            {
              path: 'broadcastDetail',
              component: () => import('../views/broadcastDetail.vue'),
              name: '音乐圈详情',
              hidden: true
            }
          ]
        },
        {
          path: '/musician',
          component: () => import('./../views/Index/musicianList.vue'),
          redirect: '/musician/list',
          name: '音乐人',
          icon: 'icon-user',
          meta: {
            keepAlive: true
          },
          children: [
            {
              path: 'list',
              component: () => import('../views/musician.vue'),
              name: '音乐人',
              hidden: true
            },
            {
              path: 'musicianDetail',
              component: () => import('../views/musicianDetail.vue'),
              name: '音乐人详情',
              hidden: true
            },
            {
              path: 'mineCenter',
              component: () => import('../views/mineCenter.vue'),
              name: '个人中心',
              hidden: true
            },
            {
              path: 'editMessage',
              component: () => import('../views/editMessage.vue'),
              name: '编辑资料',
              hidden: true
            }
          ]
        },
        {
          path: '/sellSong',
          component: () => import('./../views/SellSong/Index.vue'),
          redirect: '/sellSong/newsellAdd',
          name: '词曲投售',
          meta: {
            keepAlive: true
          },
          children: [
            {
              path: 'sellAdd',
              component: () => import('../views/sellAdd.vue'),
              name: '上传作品',
              hidden: true
            },
            {
              path: 'newsellAdd',
              component: () => import('../views/newsellAdd.vue'),
              name: '上传作品',
              hidden: true
            },
            {
              path: 'sell',
              component: () => import('../views/sell.vue'),
              name: '作品管理',
              hidden: true
            },
            {
              path: 'ad',
              component: () => import('../views/ad.vue'),
              name: '广告',
              hidden: true
            },
            {
              path: 'institution',
              component: () => import('../views/institution.vue'),
              name: '平台自审制度',
              hidden: true
            },
            {
              path: 'newPprivacy',
              component: () => import('../views/newPprivacy.vue'),
              name: '协议条款',
              hidden: true
            },
            {
              path: 'protectionLaw',
              component: () => import('../views/protectionLaw.vue'),
              name: '用户注册和未成年人保护法',
              hidden: true
            },
            {
              path: 'newPuserAgreement',
              component: () => import('../views/newPuserAgreement.vue'),
              name: 'NewP音乐用户协议',
              hidden: true
            },
            {
              path: 'privacyAgreement',
              component: () => import('../views/privacyAgreement.vue'),
              name: '隐私协议',
              hidden: true
            },
            {
              path: 'intellectualProperty',
              component: () => import('../views/intellectualProperty.vue'),
              name: '知识产权说明',
              hidden: true
            },
            {
              path: 'sellSecret',
              component: () => import('../views/sellSecret.vue'),
              name: '协议条款',
              hidden: true
            },
            {
              path: 'tortClaims',
              component: () => import('../views/tortClaims.vue'),
              name: '协议条款',
              hidden: true
            },
            {
              path: 'authentication',
              component: () => import('../views/authentication.vue'),
              name: '实名认证',
              hidden: true
            }
          ]
        },
        {
          path: '/noMenu',
          component: () => import('./../views/Index/Index.vue'),
          name: '',
          redirect: '/noMenu/collection',
          meta: {
            keepAlive: true
          },
          children: [
            {
              path: 'collection',
              component: () => import('../views/Index/Details.vue'),
              name: '在售歌曲详情',
              hidden: true
            },
            {
              path: 'mindCollection',
              component: () => import('../views/mindCollection.vue'),
              name: '我的收藏',
              hidden: true
            },
            {
              path: 'demand',
              component: () => import('../views/demand.vue'),
              name: '发布需求',
              hidden: true
            },
            {
              path: 'submitDemandSuccess',
              component: () => import('../views/submitDemandSuccess.vue'),
              name: '发布需求成功',
              hidden: true
            },
            {
              path: 'selectedSong',
              component: () => import('../views/selectedSong.vue'),
              name: '精选歌单',
              hidden: true
            },
            {
              path: 'selectedSongDetail',
              component: () => import('../views/selectedSongDetail.vue'),
              name: '精选歌单详情',
              hidden: true
            },
            {
              path: 'authorList',
              component: () => import('../views/authorList.vue'),
              name: '作者的歌词列表',
              hidden: true
            },
            {
              path: 'workList',
              component: () => import('../views/workList.vue'),
              name: '词作列表',
              hidden: true
            },
            {
              path: 'vipList',
              component: () => import('./../views/Index/vipList.vue'),
              name: '会员首页列表',
              hidden: true
            },
            {
              path: 'newVip',
              component: () => import('./../views/Index/newVip.vue'),
              name: '成为会员',
              hidden: true
            },
            {
              path: 'VipServiceAgreement',
              component: () => import('./../views/Index/VipServiceAgreement.vue'),
              name: '成为会员',
              hidden: true
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      component: () => import('../views/NewLogin.vue'),
      name: '登录',
      hidden: true
    },
    {
      path: '/Registered',
      component: () => import('./../views/Registered.vue'),
      name: '注册',
      hidden: true
    },
    // {
    //   path: '/login',
    //   // component: () => import("../views/wechatLogin.vue"),
    //   component: () => import('../views/Login.vue'),
    //   name: '登录',
    //   hidden: true
    // },
    {
      path: '/404',
      component: import('../views/404.vue'),
      name: '页面找不到了',
      hidden: true
    },
    {
      path: '*',
      hidden: true,
      redirect: {
        path: '/404'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js